import React from "react";

// react router for routing
import { BrowserRouter, Router, Switch, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoutes/PrivateRoute.js";
import { history } from "./helpers/history";

// context for state management
import { ReachbackProvider } from "./contexts/ReachbackContext.js";

// pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import NewSample from "./pages/NewSample";
import PortableSamples from "./pages/PortableSamples.jsx";
import VerticalSamples from "./pages/VerticalSamples.jsx";
import ViewSample from "./pages/ViewSample";
import ViewExperiment from "./pages/ViewExperiment";
import Unauthorized from "./pages/Unauthorized";

export default function Routes() {
  return (
    <ReachbackProvider>
      {/* <Router history={history}> */}
      <BrowserRouter>
        <Switch>
          <PrivateRoute path='/' component={Home} exact />

          <Route path='/login' component={Login} exact />

          <PrivateRoute path='/new' component={NewSample} exact />

          <PrivateRoute
            path='/portable-samples'
            component={PortableSamples}
            exact
          />
          <PrivateRoute
            path='/vertical-samples'
            component={VerticalSamples}
            exact
          />

          <PrivateRoute path='/sample/:id' component={ViewSample} exact />
          <PrivateRoute
            path='/experiment/:id'
            component={ViewExperiment}
            exact
          />

          <Route path='/unauthorizedError' component={Unauthorized} exact />
        </Switch>
        {/* </Router> */}
      </BrowserRouter>
    </ReachbackProvider>
  );
}
